<div class="update-contact-container preference-group group raised-card">
    <h2>Change Profile Password</h2>
    <div>
        <p>Your password was successfully changed!</p>
        <button type="button" class="btn btn-primary" (click)="closeComplete()">OK</button>
    </div>
</div>